import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TranslateService } from './components/localization/service';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { CommodityService } from './models/commodity-type/service';
import { PersistentDatabase } from './services/persistent-database';
import { CookieService } from './services/cookie.service';
import { TokenService } from './services/token.service';
import { NotificationService } from './services/notification.service';
import { VersionUpgradeCookieName, ReleaseVersion, DONATE_URL } from './services/constants';
import { eNotificationTypes } from './interfaces/constants';
import { MainMenuUpdateService } from './components/main-menu/main-menu-update.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
	moduleId: module.id,
	selector: 'my-app',
	templateUrl: `app.component.html`,
	styleUrls: ['app.component.css']
})

export class AppComponent implements OnInit, OnDestroy {
	@ViewChild(MainMenuComponent, { static: true }) public mainMenuComponent: MainMenuComponent;

	public donationLink = DONATE_URL;
	public isAuthenticated: boolean;
	private _subscriptions$: Subject<boolean>;

	private readonly PRIVATE_ROUTES = [ 'Administration', 'CropTypeDetails',
		'cropStages', 'CropTypes', 'flowmeter', 'GlobalSettings',
		'IgnoreSchedules', 'Localization', 'MissingStationRecords',
		'MyDashboard', 'PreviousCropDetails', 'Profile', 'Ranches', 'RanchHome',
		'SoilSensor', 'userManagement', 'statistics', 'WeatherStations',
		'WebAPIStatistics'
	];

	constructor(
		public iconRegistry: MatIconRegistry,
		public translateService: TranslateService,
		public persistentDatabase: PersistentDatabase,
		private _notificationService: NotificationService,
		private _tokenService: TokenService,
		private _mainMenuUpdateService: MainMenuUpdateService,
		private _commodityService: CommodityService,
		private _router: Router) {

		iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
	}

	ngOnInit() {
		this._subscriptions$ = new Subject();
		this.isAuthenticated = this._tokenService.isAuthenticated();

		this._router.events.pipe(takeUntil(this._subscriptions$)).subscribe(event => {
			if (event instanceof NavigationEnd) {
				let landingBodyWrapper: Element;

				landingBodyWrapper = document.querySelector('.cm-landing-body-wrapper');

				if (landingBodyWrapper) {
					landingBodyWrapper.scrollTop = 0;
				}

				const currentRoute = this._router.url.split('?')[0].substring(1); // Get the current route without query parameters and leading slash
				if (!this.isAuthenticated && this.PRIVATE_ROUTES.indexOf(currentRoute) !== -1) {
					this._router.navigate(['/login']);
				}
			}
		});

		if (CookieService.get(VersionUpgradeCookieName) === 'yes') {
			this._notificationService.generateNotifcation({
				type: eNotificationTypes.UPDATE,
				message: 'CropManage has been updated to version ' + ReleaseVersion
			});

			CookieService.delete(VersionUpgradeCookieName);
		}

		this.persistentDatabase.isGlobalNotificationVisible = this.persistentDatabase.GlobalNotificationIsVisible();
		this._commodityService.list();

		this._mainMenuUpdateService.userAuthStatusChanged$
			.pipe(takeUntil(this._subscriptions$)).subscribe(() => {

			this.isAuthenticated = this._tokenService.isAuthenticated();
		})
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public dismissGlobalNotification(): void {
		const expireDays: number = 3 * 30; // 3 months

		CookieService.set(this.persistentDatabase.globalNotificationCookieName, 'globalNotification', expireDays);
		this.persistentDatabase.isGlobalNotificationVisible = false;
	}
}
